 <template id="template-input">
  <div :class="isPreview ? 'pb-2 mb-2' : 'bg-light p-3 pb-5 mb-2'">
    <!-- menu buttons -->
    <MenuButtons
      v-if="!isPreview"
      :fieldData="fieldData"
      :collapse="collapse"
      :isHidden="isHidden"
      :label="label"
      :sectionIndex="sectionIndex"
      :fieldIndex="fieldIndex"
      v-on:toggle-field="showSettings = !showSettings"
      v-on:collapse-field="collapse = !collapse"
    />

    <!-- input content -->
    <b-collapse
      v-if="!isPreview"
      v-show="JSON.parse(!fieldData.isHidden)"
      id="collapse-1"
      :class="isPreview ? 'mt-0' : 'mt-5'"
      v-model="collapse"
    >
    </b-collapse>
      <!-- :src="apiURL + fieldData.file[translationLanguage].globeURL" -->

    <b-img-lazy
      v-if="
        fieldData.file &&
        fieldData.file[selectedLanguage] &&
        fieldData.file[selectedLanguage].globeURL
      "
      :src="apiURL+fieldData.file[selectedLanguage].globeURL"
      v-bind="mainProps"
      alt="Image"
    ></b-img-lazy>

    <!-- modal -->
    <b-modal
      ok-only
      ok-title="Close"
      size="xl"
      v-model="showSettings"
      scrollable
      title="Paragraph Settings"
    >
      <AdvanceSettingsImage
        :fieldData="fieldData"
        v-on:toggle-field="showSettings = !showSettings"
        :sectionIndex="sectionIndex"
        :fieldIndex="fieldIndex"
      />
    </b-modal>
  </div>
</template>

<script>
import AdvanceSettingsImage from "../advanceImageSettingsCompenent.vue";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import VueDropzone from "../Dropzone/VueDropzone";
import MenuButtons from "../menuButtons";
import { mapGetters, mapState } from "vuex";
export default {
  name: "ImageGroup",
  components: {
    AdvanceSettingsImage,
    MenuButtons,
    VueDropzone,
  },
  data() {
    return {
      apiURL: process.env.VUE_APP_API_URL,
      transalationLanguage: "english",
      isHidden: false,
      hasImage:
        this.fieldData.imageData && this.fieldData.imageData.url ? true : false,
      imgFile: null,
      imgUrl: null,
      condition: {},
      showToolTip: false,
      label: undefined,
      showSettings: false,
      collapse: true,
      mainProps: {
        center: true,
        // fluidGrow: true, original size enable
        blank: true,
        blankColor: "#bbb",
        height: this.fieldData.height || 400,
        width: this.fieldData.width || 800,
        class: "m1",
      },
    };
  },
  mounted() {
    // console.log("this.fieldData.imageData", this.fieldData.imageData);
  },
  computed: {
    ...mapGetters(["form1", "selectedLanguage"]),
    ...mapState(["toggleAllCoppalse"]),
  },
  watch: {
    toggleAllCoppalse(value) {
      this.collapse = value;
    },
  },
  methods: {
    getBase64(img, callback) {
      const reader = new FileReader();
      reader.addEventListener("load", () => callback(reader.result));
      reader.readAsDataURL(img);
    },

    // not in use old logic
    handleChange(info) {
      let imageFile = info.target.files[0];
      // console.log("imageFile", imageFile.type);

      if (imageFile && imageFile.type == "image/jpeg") {
        alert("You can only upload JPG and PNG file!");
      } else if (imageFile && imageFile.type == "image/png") {
        alert("You can only upload JPG and PNG file!");
      } else if (imageFile && imageFile.size > 3769152) {
        alert("Image must smaller than 4MB!");
      } else if (!imageFile) {
        alert("Image Error please try later");
      } else {
        this.getBase64(imageFile, (imageUrl) => {
          this.imgFile = imageFile;
          this.hasImage = true;
          this.imgUrl = imageUrl;
        });
      }
    },

    saveImage() {
      this.fieldData.imageData = {
        file: this.imgFile,
        url: this.imgUrl,
        height: 200,
        width: 200,
      };
    },

    removeImage() {
      this.imgFile = null;
      this.imgUrl = null;
      this.hasImage = false;
    },
  },
  props: {
    fieldData: Object,
    isPreview: Boolean,
    sectionIndex: Number,
    fieldIndex: Number,
    isDisabled: Number,
  },
};
</script>
<style scoped>
.uploaded_image_input {
  opacity: 0;
  position: inherit;
}
</style>
